export enum GameName {
  ARK_NOVA = "arkNova",
  WINGSPAN = "wingspan",
  TERRA_MYSTICA = "terraMystica",
  MARCO_POLO = "marcoPolo",
  CHALLENGERS = "challengers",
}
